import { Pill } from '@iwoca/orion';

import { ApplicationStage, countCompletedSteps } from './ApplicationStage';
import { ApplicationStep } from './ApplicationStep';
import { displayCurrency } from '../../../../../utils/DisplayCurrency';
import {
  TApplicationStage,
  TApplicationSubStage,
  TApplicationSubStageObject,
} from '../../../Customers.types';
import { SUB_STAGE_NAME_MAP } from '../CustomerInformationModal';

export const SecurityChecksStage = ({
  currentStage,
  applicationSubStages,
  limitAmount,
  limitDuration,
}: {
  currentStage: TApplicationStage['value'];
  applicationSubStages: TApplicationSubStageObject;
  limitAmount: number | null;
  limitDuration?: number | null;
}) => {
  const allSteps: TApplicationSubStage[] = [
    'id_check',
    'card_details',
    'internal_checks',
    'shareholder_check',
    'personal_guarantor_check',
  ];

  const requiredSteps = allSteps.filter(
    (step) => applicationSubStages[step]?.required,
  );

  const numCompletedSteps = countCompletedSteps(
    applicationSubStages,
    requiredSteps,
  );

  const orderedRequiredSteps = requiredSteps.sort((a, b) => {
    return (
      Number(applicationSubStages[b].completed) -
      Number(applicationSubStages[a].completed)
    );
  });

  return (
    <ApplicationStage stage="security" currentStage={currentStage}>
      <>
        <div></div>
        <div className="text-m">
          {limitAmount && (
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <span className="text-l font-bold text-success-mid">
                  {displayCurrency(limitAmount)}
                </span>
                {limitDuration && (
                  <span className="ml-xs text-m text-black">
                    in{' '}
                    {limitDuration === 1
                      ? '30 days'
                      : `${limitDuration} monthly payments`}
                  </span>
                )}
              </div>
              <Pill variant="london" size="small">
                Subject to security checks
              </Pill>
            </div>
          )}
          <div className="font-reg">
            Just a few final security checks before they are ready to use their
            Spending Limit.
          </div>
          <div className="mt-xl font-med">
            {numCompletedSteps}/{requiredSteps.length} steps completed
          </div>
        </div>
      </>
      {orderedRequiredSteps.map((step) => (
        <ApplicationStep
          key={step}
          stepText={SUB_STAGE_NAME_MAP[step]}
          isComplete={applicationSubStages[step].completed}
          showLine={false}
        />
      ))}
    </ApplicationStage>
  );
};
